import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const DefaultSEO = () => {
  const location = useLocation();
  // Don't render default SEO on blog post pages since they handle their own
  if (location.pathname.startsWith('/blog/')) {
      return null;
  }

  const title = "SuperTags | YouTube Tag Generator & SEO Tool";
  const description = "SuperTags: The ultimate free YouTube tag generator and SEO tool. Generate high-ranking tags, long-tail keywords, and track your video rankings.";
  const url = `https://supertags.online${location.pathname}`;

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "SuperTags",
    "url": "https://supertags.online",
    "description": description,
    "applicationCategory": "SEOApplication",
    "operatingSystem": "All",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    }
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content="YouTube tags, tag generator, YouTube SEO, video ranking, SuperTags" />
      <link rel="canonical" href={url} />
      
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default DefaultSEO;